<table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="jahr" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.firmaTable.jahr' | translate }} </th>
    <td class="smallField" mat-cell *matCellDef="let firmaZeit"> {{firmaZeit.jahr | date:'dd.MM.yyyy'}} </td>
  </ng-container>

  <ng-container matColumnDef="jahreszeit">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.firmaTable.jahreszeit' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let firmaZeit"> {{ firmaZeit.jahreszeit }} </td>
  </ng-container>


  <ng-container matColumnDef="tageszeit">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.firmaTable.tageszeit' | translate }} </th>
    <td mat-cell *matCellDef="let firmaZeit"> {{firmaZeit.tageszeit }} </td>
  </ng-container>


  <ng-container matColumnDef="feiertage">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.firmaTable.feiertage' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let firmaZeit"> {{ firmaZeit.anzahlFeiertage}} </td>
  </ng-container>

  <ng-container matColumnDef="arbeitstage">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.firmaTable.arbeitstage' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let firmaZeit"> {{ firmaZeit.arbeitstage}} </td>
  </ng-container>


  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td  class="smallField" mat-cell *matCellDef="let firmaZeit" >
      <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button  mat-menu-item (click)="editFirmaZeit(firmaZeit)">{{ 'pages.zeitverwaltung.actions.edit' | translate }}</button>
        <button  mat-menu-item (click)="deleteFirmaZeit(firmaZeit)">{{ 'pages.zeitverwaltung.spesenverwaltung.table.delete' | translate }}</button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row class="header-table-row" *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row class="table-row" *matRowDef="let myRowData; columns: displayedColumns" (dblclick)="editFirmaZeit(myRowData)"></tr>
</table>
